<template>
    <div class="card" style="width: 1500px;max-width:100%;">
        <div class="card-modal" style="overflow:auto;max-height:700px;">
            <div v-if="loading">
                <b-loading :is-full-page="true" v-model="loading" :can-cancel="false"></b-loading>
            </div>

            <header class="modal-card-head">
                <p class="modal-card-title">Clone Travel Policy</p>
                <button type="button" class="delete" @click="$emit('close')" />
            </header>
            <section class="modal-card-body">
                <div v-if="success" class="has-text-centered">
                    Travel policy <a @click="showPolicy(destinationPolicyId)">{{destinationPolicyName}}</a> sucessfully cloned.
                </div>
                <div v-else>
                    <b-field class="mb-4" label="Source Travel Policy">
                        {{ sourcePolicyName }}
                    </b-field>
                    <b-field class="mb-4" label="New Travel Policy Name">
                        <b-input type="text"  required validation-message="Please enter a name for this travel policy" v-model="destinationPolicyName" />
                    </b-field>
                </div>
            </section>
            <footer class="modal-card-foot">
                <b-button label="Close" @click="close()" />
                <b-button v-if="!success" :disabled="!isFormValid" @click="submit()" class="button is-primary is-wide">
                    Clone</b-button>
                <b-button v-if="destinationPolicyId"  @click="showPolicy(destinationPolicyId)" class="button is-primary is-wide">View Policy</b-button>
            </footer>
        </div>
    </div>
</template>
  
<script>

export default {
    name: "CloneTravelPolicy",
    props: {
        policyNames: Array,
        sourcePolicyId: String,
        sourcePolicyName: String,
    },
    data() {
        return {
            loading: false,
            destinationPolicyId: null,
            destinationPolicyName: null,
            success: false
        };
    },
    methods: {
        close(){
            //Reload policy list route if clone was successful
            if(this.success){
                this.$emit('save');
            }
            this.$emit('close');     
        },
        failure(msg) {
            this.$buefy.toast.open({
                duration: 5000,
                message: msg,
                position: "is-bottom",
                type: "is-danger",
            });
        },
        showPolicy(id){
          this.$router.push({ path: '/admin/travel-policy/'+id })
          this.$emit('close');
        },
        submit() {
            //Check if travel policy name is unique
            if(this.policyNames.length > 0){
                if (!this.validatePolicyName(this.destinationPolicyName)) {
                    return;
                }
            }
            var body = {
                sourcePolicyId: this.sourcePolicyId,
                destinationPolicyName: this.destinationPolicyName
            };

            this.loading = true;

            this.$app
                .huddleLabsServerCall("profile/travel-policy/duplicate", body)
                .then((result) => {
                    if (result.success) {
                        this.success = true;
                        this.destinationPolicyId = result.data.Id;

                    } else {
                        this.failure("There was an error cloning the travel policy");
                    }
                })
                .catch((error) => {
                    console.error("API error:", error);
                    this.failure("There was an error communicating with the server");
                })
                .finally(() => {
                    this.loading = false; 
                });
        },
        validatePolicyName(name){
            if (this.policyNames.includes(name)) {
                this.failure(`Travel policy "${name}" already exists. Please choose a different name.`);
                return false;
            }
            return true;
        }
    },
    mounted() { },
    computed: {
        isFormValid() {
            return !!this.destinationPolicyName;
        }
    },
};
</script>
  
<style scoped>
.is-less-bottom {
    margin-bottom: -20px;
}
</style>
  